import LocationProfileSummaryDto from "../Locations/LocationProfileSummaryDto";

export default class ContactProfileDto {
    id: string;
    agencyId: string;
    companyId: string;
    legacyId: string;
    sequenceNumber = 0;
    status: number;
    firstName: string;
    lastName: string;
    fullName: string;
    companyBrandName: string;
    emailAddress: string;
    isAgreedToMarketing = false;
    mobilePhoneNumber: string;
    otherPhoneNumber: string;
    jobTitle: string;
    positionName: string;
    positionCode: string;
    locationTypeIds: string[];
    locations: LocationProfileSummaryDto[];

}